import { FC } from "react";
import { HiOutlineXCircle } from "react-icons/hi";
import { Button, Text } from "rizzui";

interface ErrorStateProps {
    error: Error;
    onRetry: () => void;
}

const ErrorState: FC<ErrorStateProps> = ({ error, onRetry }) => {
    return (
        <div className="bg-red-50 border border-red-200 rounded-lg p-4">
            <div className="flex items-center gap-2 text-red-800">
                <HiOutlineXCircle className="h-5 w-5" />
                <span className="font-medium">Error al cargar las recogidas</span>
            </div>
            <Text className="text-red-600 text-sm mt-1">
                {error.message || 'Ha ocurrido un error inesperado'}
            </Text>
            <Button
                size="sm"
                variant="outline"
                className="mt-3"
                onClick={onRetry}
            >
                Reintentar
            </Button>
        </div>
    );
};

export default ErrorState;